import { render, staticRenderFns } from "./StudyUserConversation.vue?vue&type=template&id=d2d9990c&scoped=true&"
import script from "./StudyUserConversation.vue?vue&type=script&lang=js&"
export * from "./StudyUserConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d9990c",
  null
  
)

export default component.exports